import Navigation from 'components/Navigation/Navigation';
import NavLink from 'components/Navigation/NavLink';
import NavLinks from 'components/Navigation/NavLinks';
import SettingsLink from 'components/Navigation/SettingsLink';
import PersonalDetailsLink from 'components/Navigation/PersonalDetailsLink';
import DonationHistoryLink from 'components/Navigation/DonationHistoryLink';

export { default as Navigation } from 'components/Navigation/Navigation';
export { default as NavLink } from 'components/Navigation/NavLink';
export { default as NavLinks } from 'components/Navigation/NavLinks';
export { default as SettingsLink } from 'components/Navigation/SettingsLink';
export { default as PersonalDetailsLink } from 'components/Navigation/PersonalDetailsLink';
export { default as DonationHistoryLink } from 'components/Navigation/DonationHistoryLink';

export default {
  Navigation,
  NavLink,
  NavLinks,
  SettingsLink,
  PersonalDetailsLink,
  DonationHistoryLink,
};
